<template>
    <div class="parallax-rounded-image-component"
        :style="{ backgroundImage: `url(${backgroundImage}` }"
    ></div>
</template>

<script>
export default {
    props: {
        backgroundImage: {
            type: String,
            required: true,
        },
        height: {
            type: Number,
            required: true,
        },
    },

    data() {
        return {
            top: null,
        }
    },

    methods: {
        observer([entry]) {
            if (entry.isIntersecting) {
                if (! this.top) {
                    this.top = entry.boundingClientRect.top + this.height;
                }
                window.addEventListener('scroll', this.setBackgroundPosition);
            } else {
                window.removeEventListener('scroll', this.setBackgroundPosition);
            }
        },
        setBackgroundPosition() {
            let percent = (this.$el.getBoundingClientRect().top + this.height) / this.top * 100;
            let pixels = (this.height / 2) / 100 * percent * -1; // this.height / 2 = walk
            if (pixels > 0) {
                pixels = 0;
            }
            this.$el.style.backgroundPosition = `center ${pixels}px`;
        }
    },

    mounted () {
        let observerConfig = {
            root: null,
            rootMargin: '0px',
            threshold: 0
        };
        let observer = new IntersectionObserver(this.observer, observerConfig);
        observer.observe(this.$el);
    },
}
</script>

<style scoped>
.parallax-rounded-image-component {
    border-radius: 50%;
    background-repeat: no-repeat;
    background-position: center center;
}
</style>
